import { Box } from "@husqvarna/ui-core";
import { Navigate, Route, Routes } from "react-router";
import Site from "./pages/Site";
import Services from "./pages/Services";
import GeneralInfo from "./pages/GeneralInfo";
import CurrentSetup from "./pages/CurrentSetup";
import List from "./pages/List";
import ProjectLayout from "./components/ProjectLayout";
import Finance from "./pages/Finance";

const Projects = () => (
  <Box container className="tcsp-projects" width="full">
    <Routes>
      <Route index element={(<List />)} />
      <Route path=":projectId" element={(<ProjectLayout />)}>
        <Route index element={<Navigate to="new-setup/create-area" replace />} />
        <Route path="general-info" element={(<GeneralInfo />)} />
        <Route path="new-setup">
          <Route index element={<Navigate to="create-area" replace />} />
          <Route path="create-area" element={(<Site />)} />
          <Route path="add-mower" element={(<Site />)} />
        </Route>
        <Route path="current-setup" element={(<CurrentSetup />)} />
        <Route path="equipment" element={(<Site />)} />
        <Route path="service" element={(<Services />)} />
        <Route path="finance" element={(<Finance />)} />
      </Route>
    </Routes>
  </Box>
);

export default Projects;